<template>
  <div class="act">
    <!-- <img 
      src="@/assets/GuangzhouUnicomImg/new2/bg.png"
      class="act-bg"
      alt=""
    />
     -->
     <LogoHeader 
        :logoPath="require('@/assets/logo/elm/elm-unicom.png')"
        altText="中国联通"
        />
    <img
      class="queryBtn"
      src="@/assets/GuangzhouUnicomImg/queryBtn.png"
      alt=""
      @click="queryOrder"
    />
    <img
      class="kefuBtn"
      src="@/assets/GuangzhouUnicomImg/service.png"
      alt=""
      @click="openKefu"
    />
    <div class="bottomBtn" v-show="bottomBtn">
      <img
        @click="onSubmit"
        class="bottomBtnImg"
        src="@/assets/GuangzhouUnicomImg/lqBtn.png"
        alt=""
      />
    </div>
    <div class="content">
      <img src="@/assets/lttop.png" class="topImg" alt="" />
      <div class="contentBox1">
        <div class="container" v-if="false">
          <div class="header2" style="font-weight:bold;font-size:20px;display:flex;align-items:center;"><span style="color:#ff9800;font-size:22px;margin-right:8px;">⚠️</span>重要提醒</div>
          <div class="content">
            <div class="textIndent highlight warning-box" style="font-size: 12px;">
              <div style="margin-bottom:8px; ">公安部提示:请勿将已登记您本人身份证信息的号卡转卖、租借他人使用，请及时挂失、注销已丢失号卡，保护个人信息安全。涉嫌诈骗等违法犯罪行为的号码，实名登记机主需承担法律责任。</div>
              <div style="font-weight:bold;margin-bottom:4px;">客户“三切勿”温馨提示</div>
              <div style="margin-bottom:4px;">请客户注重个人信息保护：</div>
              <ul class="warning-list">
                <li>一、切勿将短信验证码告知他人，务必自行输入</li>
                <li>二、切勿将本人办理的手机卡买卖、出借和给予他人</li>
                <li>三、切勿协助他人进行身份信息认证</li>
              </ul>
              <div style="margin-top:4px;">上述行为都存在信息安全隐患，甚至协助不法分子实施犯罪。</div>
            </div>
          </div>

        </div>

        <div class="container">
          <div class="header">套餐内容</div>
          
          <div class="content">
            <div class="zfxqTable3">
              <table style="width:100%;border-collapse:collapse;table-layout:fixed;">
                <colgroup>
                  <col style="width: 20.5%;" />
                  <col style="width: 23.5%;" />
                  <col style="width: 23.5%;" />
                  <col style="width: 23.5%;" />
                </colgroup>
                <tr>
                  <th class="zTh">套餐月租</th>
                  <th class="zTh">39元/月</th>
                  <th class="zTh">49元/月</th>
                  <th class="zTh">60元/月</th>
                </tr>
                <tr>
                  <th class="zTh">套餐说明</th>
                  <td class="zTd left">
                    <strong class="blueText">1500分钟</strong>语音通话<br>
                    <strong class="blueText">165G</strong>流量<br />
                    <span class="small"><span style="padding-left: 10px;">105G通用流量</span><br/><span style="padding-left: 10px;">60G定向流量</span></span><br>
                  </td>
                  <td class="zTd left">
                    <strong class="blueText">1500分钟</strong>语音通话<br>
                    <strong class="blueText">165G</strong>流量<br />
                    <span class="small"><span style="padding-left: 10px;">135G通用流量</span><br/><span style="padding-left: 10px;">30G定向流量</span></span><br>
                  </td>
                  <td class="zTd left">
                    <strong class="blueText">2000分钟</strong>语音通话<br>
                    <strong class="blueText">205G</strong>流量<br />
                    <span class="small"><span style="padding-left: 10px;">175G通用流量</span><br/><span style="padding-left: 10px;">30G定向流量</span></span><br>
                  </td>
                </tr>
                <tr>
                  <th class="zTh">封顶规则</th>
                  <td class="zTd left" colspan="3">国内语音拨打0.15元/分钟，套外流量放心用：0-1G套外国内流量按照0.02元/MB计费，累计至250MB （5元）后，按照5元/GB计费，流量超过1GB后仍按上述标准计收，以此类推。国内短、彩信0.1元/条。</td>
                </tr>
                <tr>
                  <th class="zTh">套餐资费说明</th>
                  <td class="zTd left" colspan="3">上网当月套餐外流量消费600元封顶，封顶费用包含按套餐外资费收取的上网流量费，不含用户订购的各种流量包功能费，当月套餐外流量消费达到封顶值（600元）则暂停当月上网服务，次月初自动开通；用户可自行申请继续使用，按照套餐外资费收取相应费用。</td>
                </tr>
              </table>
            </div>
          </div>

        </div>
      </div>
      <div class="contentBox2">
        <div class="userInfo">
          <van-form @submit="onSubmit" :label-width="0">
            <div class="form-item">
              <div class="form-label form-label__reqiured">套餐</div>
              <van-field
                class="form-field"
                v-model="comboName"
                name="cardName"
                placeholder="请选择套餐"
                readonly
                @click="showTCBox"
              />
              <van-popup v-model="tcShow" position="bottom">
                <div class="tcBox">
                  <div class="topBox">
                    <!-- <div class="close" @click="closeTC">取消</div>
                    <div class="define" @click="defineTC">确定</div> -->
                    <van-icon name="cross" size="24px" color="#999" @click="closeTC"/>
                  </div>
                  <div class="content">
                    <div
                      :class="['tcItem', { active: index == selIndex }]"
                      v-for="(item, index) in tcList"
                      :key="index"
                      @click="changeTC(index)"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </van-popup>
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">姓名</div>
              <van-field
                class="form-field"
                v-model="cardName"
                name="cardName"
                placeholder="与身份证一致（已加密）"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">身份证号</div>
              <van-field
                class="form-field"
                v-model="cardNo"
                name="cardNo"
                maxlength="18"
                placeholder="仅用于本次业务（已加密）"
                :rules="[
                  {
                    validator: sfzValidator,
                    message: '请输入正确身份证号码',
                  },
                ]"
              />
            </div>
            <div class="form-item">
              <div class="form-label form-label__reqiured">联系电话</div>
              <van-field
                class="form-field"
                v-model="contactsMobile"
                maxlength="11"
                name="contactsMobile"
                placeholder="收货手机号码（已加密）"
                :rules="[{ pattern, message: '请输入正确手机号码' }]"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">号码归属地</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="cardAttribution"
                :value="cardAttribution"
                placeholder="请选择归属地区省市"
                @click="showPicker = true"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">收货城市</div>
              <van-field
                readonly
                clickable
                class="form-field"
                name="contactsCity"
                :value="contactsCity"
                placeholder="请选择收货省市区"
                @click="showArea = true"
              />
              <van-popup v-model="showArea" position="bottom">
                <van-picker
                  show-toolbar
                  :columns="areaList"
                  @confirm="onConfirm"
                />
              </van-popup>
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">详细地址</div>
              <van-field
                class="form-field"
                v-model="contactsAddress"
                name="contactsAddress"
                placeholder="请输入详细的收货地址"
              />
            </div>

            <div class="form-item">
              <div class="form-label form-label__reqiured">免费选号</div>
              <van-field
                readonly
                clickable
                class="form-field"
                :value="comboMobile"
                name="comboMobile"
                placeholder="请选择号码"
                @click="numGuessSelect()"
              />
              <van-dialog
                v-model="showMobilePicker"
                :showConfirmButton="false"
                class="numDialog"
              >
                <div class="numClose">
                  <van-icon
                    name="close"
                    @click="showMobilePicker = false"
                    size="1.2rem"
                  />
                </div>
                <div class="numBox">
                  <div
                    v-for="item in numList"
                    :key="item"
                    class="numContent"
                    @click="selcetNum(item)"
                  >
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="numBtn">
                  <van-button
                    icon="replay"
                    type="default"
                    native-type="button"
                    @click="numGuessSelect()"
                    >换一换</van-button
                  >
                </div>
              </van-dialog>
            </div>
            <div class="form-item" v-if="zpActivety">
              <div class="form-label form-label__reqiured">
                {{ simSpiActivity.giftAttrName }}
              </div>
              <van-field
                v-if="sizeList.length <= 1"
                class="form-field"
                :value="giftInfo"
                name="contactsAddress"
                placeholder="请选择赠品尺码"
              />
              <select
                v-else
                class="selectBox"
                v-model="giftInfo"
                @change="changeSize"
              >
                <option value="" disabled selected>请选择尺码</option>
                <option v-for="(item, index) in sizeList" :key="index">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="activeInfo" v-if="zpActivety">
              <div class="activeLeft">{{ simSpiActivity.tips }}</div>
              <div class="activeRight" @click="openTips">
                赠送详情
                <van-icon name="question-o" />
              </div>
            </div>
            <div
              class="dealText" style="display: none;"
              v-if="dealTextList && dealTextList.length > 0"
            >
              <div class="read">
                <van-checkbox v-model="checkDeal" icon-size="16px" />
                我已阅读并同意
                <span
                  class="deal"
                  @click="toUnicomDeal(item.components)"
                  v-for="(item, index) in dealTextList"
                  :key="index"
                  ><span class="xy">《{{ item.name }}》</span>
                </span>
              </div>
            </div>
          </van-form>
          <div class="btn" ref="sumitBtm" @click="onSubmit">
            <img
              class="lqBtn"
              src="@/assets/GuangzhouUnicomImg/lqBtn.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="contentBox1">
        <div class="bmInfo">
          <div class="bmTitle">最新报名用户</div>
          <div class="bmContent">
            <vue-seamless-scroll
              class="scroll-content"
              :class-option="classOption"
              :data="winningList"
            >
              <div
                class="bmItem"
                v-for="(item, index) in winningList"
                :key="index"
              >
                <div class="bmItemName">{{ item.name }}</div>
                <div class="bmItemPhone">{{ item.phone }}</div>
                <div class="bmItemTime">{{ item.time }}分钟前</div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <!-- <div class="tcysInfo">
          <img
            class="tcysImg"
            src="@/assets/GuangzhouUnicomImg/new2/tcys.png"
            alt=""
          />
        </div> -->

        <div class="container">
          <div class="header">资费详情</div>
          <div class="content">
            <div class="section">
              <h3>套餐说明：</h3>
              <p>
              <b>套餐一：月租39元 。</b><br>
                国内语音拨打1500分钟，国内流量105GB，60G定向流量，国内接听免费，赠送来显。<br>
              <b>套餐二：月租49元 。</b><br>
                国内语音拨打1500分钟，国内流量135GB，30G定向流量，国内接听免费，赠送来显。<br>
              <b>套餐三：月租60元 。</b><br>
                国内语音拨打2000分钟，国内流量175GB，30G定向流量，国内接听免费，赠送来显。<br>
              <b>套外资费：</b>国内语音拨打0.15元/分钟，套外流量放心用：0-1G套外国内流量按照0.02元/MB计费，累计至250MB （5元）后，按照5元/GB计费，流量超过1GB后仍按上述标准计收，以此类推。国内短、彩信0.1元/条。 封顶规则：上网当月套餐外流量消费600元封顶，封顶费用包含按套餐外资费收取的上网流量费，不含用户订购的各种流量包功能费，当月套餐外流量消费达到封顶值（600元）则暂停当月上网服务，次月初自动开通；用户可自行申请继续使用，按照套餐外资费收取相应费用。<br>
              <b>定向流量详细说明:</b><br>
                1、定向流里仅限用户在广东区域范围使用，广东区域指行政划分的广东省管辖区域。广东省区域外、港澳台、国际漫游流里按照正常资费收取。<br>
                2、适用APP范围:适用阿里系、腾讯系、头条系指定范围APP。非指定范围APP不保证免流生效。具体点击以下链接查询了解:<br>
              <a href="https://www.10010.com/wt_links/index.html#/announcementDetail?announcementId=04aefaf093dab0ff0193fcffc26f0029&pageSize=12&pageNo=1">https://www.10010.com/wt_links/index.html#/announcementDetail?announcementId=04aefaf093dab0ff0193fcffc26f0029&pageSize=12&pageNo=1</a>
            </p>
            </div>
          </div>
        </div>

      
        <div class="container">
          <div class="header">常见问题</div>
          <div class="content">
            <div class="section">
              <p>1、本业务向年满18-60周岁并使用身份证的用户办理，无身份证、黑名单用户等特殊群体无法办理，请知悉。</p>
              <p>2、此卡禁止用于电话销售/推销/金融等类似骚扰诈骗等形式的用途，一旦被投诉或系统监测到会导致停机，无法继续享受优惠或使用。</p>
              <p>3、产品及相关优惠活动仅限指定互联网渠道销售，产品最终名称以联通系统展示为准。在使用过程中若遇任何问题，可致电<span style="color:#3860cf;font-weight:bold;">18688283295(陈经理)</span>客服热线咨询。</p>
              <p>4、特别注意:部分APP享受免流服务前需先至对应APP进行绑定激活，专属流量使用范围可能因不可抗力或第三方原因发生变更，详情可前往www.10010.com查询了解。</p>
              <p>5、如需销户，可自行登录中国联通APP，搜索“销户”，按提示提交销户申请。也可持本人身份证，前往当地中国联通营业厅进行销户办理。</p>
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="showKefu"
      title="扫码联系客服"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
    >
      <div class="kefuBox">
        <!-- <img
          class="kefuQRCode"
          src="@/assets/GuangzhouUnicomImg/new/kefuQRCode.png"
          alt=""
        /> -->
      </div>
    </van-dialog>
    <van-dialog
      v-model="showSetSize"
      title="赠品尺码"
      confirm-button-text="确定"
      confirm-button-color="#3860cf"
      @confirm="confirmSize"
    >
      <div class="sizeBox">
        <div class="sizeBoxList">
          <div
            :class="['sItem', { active: index == sizeIndex }]"
            @click="changeSize(index)"
            v-for="(item, index) in sizeList"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="tipsShow"
      confirm-button-text="关闭"
      confirm-button-color="#3860cf"
      @confirm="closeTips"
    >
      <div class="dialogTips">
        <img class="tipsImg" :src="tipsImg" alt="" />
      </div>
    </van-dialog>
    <dialogTips
      :text="dialogTips.text"
      :icon="dialogTips.icon"
      :iconColor="dialogTips.iconColor"
      :show="dialogTips.show"
      :confirmButtonText="dialogTips.confirmButtonText"
      @confirm="confirmTips"
    ></dialogTips>
  </div>
</template>

<script>
import {
  Form,
  Field,
  Popup,
  Picker,
  Dialog,
  Icon,
  Checkbox,
  Button,
} from "vant";
import areaData from "../../public/static/areaData.json";
// import operatorData from "../../public/static/operatorData.json";
import { http } from "@/api/http";
import moment from "moment";
import dialogTips from "@/pages/components/dialogTips";
import LogoHeader from "@/components/LogoHeader.vue";
// import Countdown from "./components/Countdown.vue";
// import { deepClone } from "@/utils/utils";
export default {
  name: "foshanUnicomElm01",
  components: {
    vanForm: Form,
    vanField: Field,
    vanPopup: Popup,
    vanPicker: Picker,
    vanButton: Button,
    vanIcon: Icon,
    vanCheckbox: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    dialogTips,
    LogoHeader,
    // Countdown,
  },
  data() {
    return {
      areaList: [],
      comboName: "",
      cardName: "",
      cardNo: "",
      contactsMobile: "",
      cardAttribution: "",
      cardAttributionCode: "",
      comboMobile: "",
      contactsCity: "",
      contactsAddress: "",
      columns: [],
      showArea: false,
      showMobile: "",
      checkDeal: true,
      showPicker: false,
      // mapData: [],
      mtBmUid: "",
      spiId: "",
      cardAttributionProvince: "",
      showMobilePicker: false,
      numList: [],
      pattern: /^1[3456789]\d{9}$/,
      // selectCombo: {},
      goodsCode: null,
      dealTextList: [], //协议数据
      areaData: {},
      areaData2: {}, //号码归属地
      saleId: null,
      scrollY: 0,
      bottomBtn: false,
      showBtnTop: 0,
      oIndex: 0,
      comboData: {},
      channel: "",
      winningList: [
        { name: "张**", phone: "137******3", time: 5 },
        { name: "李**", phone: "138******6", time: 7 },
        { name: "欧阳**", phone: "170******1", time: 7 },
        { name: "陈**", phone: "182******6", time: 9 },
        { name: "林**", phone: "187******3", time: 10 },
        { name: "张**", phone: "153******2", time: 10 },
        { name: "黄**", phone: "138******5", time: 11 },
        { name: "王**", phone: "136******1", time: 12 },
        { name: "李**", phone: "182******7", time: 12 },
        { name: "陈**", phone: "189******8", time: 13 },

        // 更多中奖者...
      ],
      classOption: {
        singleHeight: 40,
        waitTime: 5000,
      },
      showKefu: false,
      endTime: moment("2024/12/25 09:59:59").valueOf(),
      isEnded: false,
      sizeList: [],
      showSetSize: false,
      giftInfo: "",
      sizeIndex: 0,
      zpActivety: false,
      simSpiActivity: null,
      tipsShow: false,
      tipsImg: "",
      dialogTips: {
        text: "",
        icon: "",
        iconColor: "",
        show: false,
        confirmButtonText: "",
      },
      noClick: false,
      goodsName: "",
      selNumTips: "请选择号码",
      tcShow: false,
      selIndex: -1,
      tcList: [
        {
          name: "39元/月 1500分钟+165G流量骑士卡",
          title: "FSLT-ELM39",
          comboCode: "FSLT-ELM39",
          goodsCode: "FSLT-ELM39",
          price: 39,
        },
        // {
        //   name: "52元/月 2800分钟+220G流量骑士卡",
        //   title: "FSLT-ELM52",
        //   comboCode: "FSLT-ELM52",
        //   goodsCode: "FSLT-ELM52",
        //   price: 52,
        // }
        {
          name: "49元/月 1500分钟+165G流量骑士卡",
          title: "FSLT-ELM49",
          comboCode: "FSLT-ELM49",
          goodsCode: "FSLT-ELM49",
          price: 39,
        },
        {
          name: "60元/月 2000分钟+205G流量骑士卡",
          title: "FSLT-ELM60",
          comboCode: "FSLT-ELM60",
          goodsCode: "FSLT-ELM60",
          price: 39,
        }
      ],
      comboCode: "",
      //号卡归属省市
      cardAreaData: {
        text: "",
        code: "0",
        children: [
          {
            text: "北京市",
            "code": "110000",
            "children": [
              {
                "text": "北京市",
                "code": "110000"
              }
            ]
          }
        ]
      },
      // 表单缓存 key
      formCacheKey: "FSLT_ELM_FORM_CACHE",
      // 表单缓存有效期：24小时
      formCacheTTL: 24 * 60 * 60 * 1000
    };
  },
  created() {
    this.mtBmUid = localStorage.getItem("mtBmUid");
    this.spiId = localStorage.getItem("gysCode");
    this.saleId = localStorage.getItem("saleId");
    this.oIndex = localStorage.getItem("oIndex");
    this.channel = localStorage.getItem("channel");
    this.areaList = [];
    this.areaList.push(areaData["440000"]);
    this.initAreaList2();
    this.cardAttribution = "佛山市";
    this.cardAttributionProvince = "440000";
    this.cardAttributionCode = "440600";
    // this.comboData = {
    //   comboLevel: 39,
    //   abstractImg: "",
    //   comboName: "29元/月骑手卡套餐",
    //   showMobile: "true",
    //   goodsCode: this.oIndex,
    //   comboCode: this.oIndex,
    // };

    // this.comboName = this.comboData.comboName;
    // this.goodsName = this.comboData.comboName;
    // this.dealTextList = [
    //   {
    //     name: "入网协议",
    //     components: "gdydruwangxy",
    //     },
    //     {
    //       name: "用户隐私协议",
    //       components: "gdydyhxsxy",
    //     },
    //     {
    //       name: "电子渠道开户服务协议",
    //       components: "gddzqdkhfwxy",
    //     },{
    //       name: "中国移动广东公司电子渠道商品销售服务协议",
    //       components: "gdyddzqdspxsfwxy",
    //     },{
    //       name: "个人/单位在通信企业申请通讯工具涉电信网络新型违法犯罪法律责任及防范提示告知书",
    //       components: "gdydtxqysqtxgjsdxwlxxwffzflzrjfftsgzs",
    //     },{
    //       name: "中国移动权益超市服务协议",
    //       components: "gdydqycsfwxy",
    //     },{
    //       name: "解约条款",
    //       components: "gdydjytk",
    //     }
    // ];
    this.simViewLogAdd();
    this.getActivityBySpi();
    // 加载表单缓存
    //this.loadFormCache();
  },
  watch: {
    selIndex(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.comboMobile = "";
        this.comboName = this.tcList[newVal].name;
        this.goodsName = this.tcList[newVal].name;
      }
    },
    // cardAttribution(newVal, oldVal) {
    //   if (oldVal !== newVal) {
    //     this.comboMobile = "";
    //   }
    // },
    // cardAttribution(newVal, oldVal) {
    //   if (oldVal !== newVal) {
    //     this.comboMobile = "";
    //     let obj = {};
    //     let arr = [];
    //     console.log("newVal =>", newVal);
    //     if (newVal.includes("西藏") || newVal.includes("新疆")) {
    //       if (newVal.includes("西藏")) {
    //         obj = deepClone(areaData["540000"]);
    //       } else if (newVal.includes("新疆")) {
    //         obj = deepClone(areaData["650000"]);
    //       }
    //       this.contactsCity = "";
    //       this.areaData = [];
    //     } else {
    //       obj = deepClone(areaData["gzuni0000000001"]);
    //     }
    //     arr.push(obj);
    //     this.areaList = arr;
    //     console.log("areaList =>", this.areaList);
    //   }
    // },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(() => {
      const height = this.$refs.sumitBtm.offsetTop;
      this.showBtnTop = height + window.innerHeight;
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    changeTC(index) {
      this.selIndex = index;
      this.tcShow = false;
    },
    showTCBox() {
      this.tcShow = true;
    },
  
    closeTC() {
      this.tcShow = false;
    },

    confirmTips() {
      this.dialogTips.show = false;
      this.$forceUpdate();
      if (this.dialogTips.icon == "success") {
        window.location.reload();
      }
    },
    openTips() {
      this.tipsImg = this.simSpiActivity.imgPath;
      // console.log("tipsImg =>",this.tipsImg)
      this.tipsShow = true;
    },
    closeTips() {
      this.tipsShow = false;
    },
    async simViewLogAdd() {
      let params = {
        mtBmUid: this.oIndex,
        spiId: this.spiId,
        clickName: this.oIndex,
        uid: "",
      };
      http("simViewLogAdd", params);
    },
    errorAdd(msg, remark, params) {
      let newParams = {
        mtBmUid: this.oIndex,
        spiId: this.spiId,
        clickName: `ERROR-${this.oIndex}-${msg}`,
        uid: params.contactsMobile,
        remark,
        param: JSON.stringify(params),
      };
      http("simViewLogAdd", newParams);
    },
    confirmSize() {
      this.giftInfo = this.sizeList[this.sizeIndex].value;
    },
    setSize(item) {
      this.giftInfo = item.value;
    },
    changeSize(e) {
      console.log("e =>", e.target.value);
      this.giftInfo = e.target.value;
      // this.sizeIndex = index;
    },
    openSetMeal() {
      this.showSetSize = true;
    },
    ended() {
      this.isEnded = true;
    },
    openKefu() {
      // this.showKefu = true;
      window.location.href =
        "https://work.weixin.qq.com/kfid/kfc2ef46aff0a7d85a6";
    },
    queryOrder() {
      window.location.href = "https://m.10010.com/myorder/?isNew=1&entrycode=W002";
    },
    async getActivityBySpi() {
      let params = {
        spiId: this.spiId,
      };

      const res = await http("getActivityBySpi", params, { hideLoading: true });
      console.log("res=>", res);
      if (res && res.code == 200 && res.result.hasActivity) {
        let list = [];
        let sList = JSON.parse(res.result.simSpiActivity.giftSelectList);
        let obj = null;
        sList.map((v) => {
          for (let key in v) {
            obj = {
              name: key,
              value: v[key],
            };
          }
          list.push(obj);
        });
        if (list.length <= 1) {
          this.giftInfo = list[0].value;
        }
        this.sizeList = list;
        this.simSpiActivity = res.result.simSpiActivity;
        this.zpActivety = true;
        this.tipsImg = res.result.simSpiActivity.imgAlertPath;
        this.tipsShow = true;
      } else {
        this.zpActivety = false;
      }
    },
    async onSubmit(values) {
      if (this.noClick) {
        return;
      } else if (!this.checkDeal) {
        this.$toast("请阅读并同意协议");
        return;
      } else if (!this.comboName) {
        this.$toast("请选择套餐");
        return;
      } else if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      }
       else if (!this.comboMobile) {
        this.$toast("请选择号码");
        return;
      }
      else if (!this.contactsCity) {
        this.$toast("请选择收货区地址");
        return;
      } else if (!this.contactsAddress) {
        this.$toast("请输入详细的收货地址");
        return;
      } else if (this.contactsAddress.length < 4) {
        this.$toast("详细地址长度不少于4位");
        return;
      } else if (this.zpActivety && !this.giftInfo) {
        this.$toast("请选择赠品尺码");
        return;
      }

      // 通过校验后，写入表单缓存
      //this.saveFormCache();

      let params = {
        comboLevel: this.tcList[this.selIndex].price,
        comboName: this.tcList[this.selIndex].name,
        cardAttribution: this.cardAttributionCode,
        goodsName: this.goodsName,
        mtBmUid: this.mtBmUid,
        spiDepartId: this.spiId,
        comboMobile: this.comboMobile,
        cardAttributionProvince:this.cardAttributionProvince,
        contactsProvince: this.areaData.pName, // 省
        contactsProvinceCode: this.areaData.pCode, // 省
        contactsCity: this.areaData.cName, // 市
        contactsCityCode: this.areaData.cCode, // 市
        contactsArea: this.areaData.aName, // 区
        contactsAreaCode: this.areaData.aCode, // 区
        comboCode: this.tcList[this.selIndex].comboCode,
        goodsCode: this.tcList[this.selIndex].goodsCode,
        saleId: this.saleId,
        cardName: this.cardName,
        cardNo: this.cardNo,
        channelCode: "",
        checkCode: "",
        contactsAddress: this.contactsAddress,
        contactsMobile: this.contactsMobile,
        feeType: "",
        numberId: "",
        registerMobile: "",
        tractAddress: "",
        uid: "",
        channel: this.channel,
      };
      // if (this.areaData2.pCode != this.areaData.pCode) {
      //   this.errorAdd("GSDSHDZBYZ", "号码归属省份和收货省份不一致", params);
      //   return this.$toast("号码归属省份需和收货省份一致");
      // }
      if (this.zpActivety) {
        params = {
          ...params,
          giftInfo: this.giftInfo,
        };
      }
      this.noClick = true;
      let paramsData = Object.assign(values, params);
      const { code, message, result } = await http("simOrder", paramsData);
      this.noClick = false;
      if (code == 200) {
        if (result.shortUrl != null && result.shortUrl != "") {
          //跳转到运营商处理
          window.location.href = result.shortUrl;
          return;
        }
        this.dialogTips = {
          text: "提交成功，请留意快递信息，收到的手机号必须与您选择的号码一致，不一致将无法享受套餐相应优惠或活动赠送礼品，如发现号码不一致，请立即联系在线客服处理",
          icon: "success",
          iconColor: "#07C160",
          show: true,
          confirmButtonText: "确定",
        };
        // 提交成功后可选择清理缓存，如需长期保留可注释下一行
        // this.clearFormCache();
      } else {
        this.dialogTips = {
          text: message,
          icon: "warning",
          iconColor: "#FF4444",
          show: true,
          confirmButtonText: "关闭",
        };
      }
    },
    handleScroll() {
      this.scrollY = window.scrollY;
      if (this.scrollY >= this.showBtnTop) {
        if (!this.bottomBtn) {
          this.bottomBtn = true;
        }
      } else {
        if (this.bottomBtn) {
          this.bottomBtn = false;
        }
      }
      // console.log("Scroll Y position:", this.scrollY);
    },
    selcetNum(item) {
      this.comboMobile = item;
      this.showMobilePicker = false;
    },
    selectCity(values, indexs) {
      // console.log("value =>",value)
      // this.cardAttribution = value.text;
      // this.cardAttributionProvince = value.value;

      this.areaData2 = {
        pName:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList2[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList2[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
      };
      this.cardAttribution = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      this.showPicker = false;
    },
    onConfirm(values, indexs) {
      this.areaData = {
        pName:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].text
            : "", //省
        pCode:
          indexs.length > 1
            ? this.areaList[indexs[0]].children[indexs[1]].code
            : "",
        cName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .text
            : "", //市
        cCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .code
            : "",
        aName:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].text
            : "", //区
        aCode:
          indexs.length > 2
            ? this.areaList[indexs[0]].children[indexs[1]].children[indexs[2]]
                .children[indexs[3]].code
            : "",
      };
      console.log("areaData =>", this.areaData);
      this.contactsCity = values
        .filter((item) => !!item)
        .map((item) => item)
        .join("");
      // this.mapData = values;
      this.showArea = false;
    },
    sfzValidator(val) {
      return /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
        val
      );
    },

    async numGuessSelect() {
      if (!this.cardName) {
        this.$toast("请填写姓名");
        return;
      } else if (!this.cardNo) {
        this.$toast("请填写身份证号码");
        return;
      } else if (!this.contactsMobile) {
        this.$toast("请填写联系电话");
        return;
      } else if (!this.contactsCity) {
        this.$toast("请选择收货地址");
        return;
      } else if (!this.cardAttribution) {
        this.$toast("请选择号码归属地");
        return;
      }

      let params = {
        spiId: this.spiId,
        cityCode: this.cardAttributionCode,
        goodsId: this.tcList[this.selIndex].comboCode,
        provinceCode: this.cardAttributionProvince,
      };
      const { code, result, message } = await http(
        "simNumGuessSelect",
        params
      );
      if (code !== 200) return this.$toast(message);
      if (code == 200) {
        console.log("result =>", result);
        this.numList = result;
        this.showMobilePicker = true;
      }
    },
    initAreaList2() {
      let pArr = [];
      let cArr = [];
      let pObj = {};
      let cObj = {};
      let areaList = [];
      areaList.push(this.cardAreaData);
      // areaList.push(areaData["c5ae2ee23e66400cac01eff3246498dd2"]);
      areaList.map((v) => {
        v.children.map((val) => {
          cArr = [];
          val.children.map((value) => {
            cObj = {
              text: value.text,
              code: value.code,
            };
            cArr.push(cObj);
          });
          pObj = {
            text: val.text,
            code: val.code,
            children: cArr,
          };
          pArr.push(pObj);
        });
      });
      console.log("pArr =>", pArr);
      this.areaList2 = [
        {
          text: "",
          code: "0",
          children: pArr,
        },
      ];
    },
    toUnicomDeal(components) {
      this.$router.push({
        name: components,
      });
    },
    getCard() {
      const queryData = Object.assign({}, this.swiperMsg, {
        spiId: this.spiId,
        mtBmUid: this.mtBmUid,
      });
      delete queryData.abstractImg;
      this.$router.push({
        name: "GuangzhouUHanding",
        query: queryData,
      });
    },
    // 将表单信息写入缓存
    saveFormCache() {
      try {
        const payload = {
          selIndex: this.selIndex,
          comboName: this.comboName,
          goodsName: this.goodsName,
          cardName: this.cardName,
          cardNo: this.cardNo,
          contactsMobile: this.contactsMobile,
          cardAttribution: this.cardAttribution,
          cardAttributionCode: this.cardAttributionCode,
          cardAttributionProvince: this.cardAttributionProvince,
          contactsCity: this.contactsCity,
          contactsAddress: this.contactsAddress,
          areaData: this.areaData,
          giftInfo: this.giftInfo,
          zpActivety: this.zpActivety
        };
        const wrapped = {
          v: payload,
          expiresAt: Date.now() + this.formCacheTTL,
        };
        localStorage.setItem(this.formCacheKey, JSON.stringify(wrapped));
      } catch (e) {
        // 忽略缓存异常
      }
    },
    // 从缓存恢复表单信息
    loadFormCache() {
      try {
        const cache = localStorage.getItem(this.formCacheKey);
        if (!cache) return;
        const parsed = JSON.parse(cache);
        if (!parsed || !parsed.expiresAt || Date.now() > parsed.expiresAt) {
          localStorage.removeItem(this.formCacheKey);
          return;
        }
        const data = parsed.v || {};
        if (data.selIndex !== undefined && data.selIndex !== null) {
          this.selIndex = data.selIndex;
        }
        this.comboName = data.comboName || this.comboName;
        this.goodsName = data.goodsName || this.goodsName;
        this.cardName = data.cardName || this.cardName;
        this.cardNo = data.cardNo || this.cardNo;
        this.contactsMobile = data.contactsMobile || this.contactsMobile;
        this.cardAttribution = data.cardAttribution || this.cardAttribution;
        this.cardAttributionCode = data.cardAttributionCode || this.cardAttributionCode;
        this.cardAttributionProvince = data.cardAttributionProvince || this.cardAttributionProvince;
        this.contactsCity = data.contactsCity || this.contactsCity;
        this.contactsAddress = data.contactsAddress || this.contactsAddress;
        this.areaData = data.areaData || this.areaData;
        this.giftInfo = data.giftInfo || this.giftInfo;
        // 不自动还原号码，按当前逻辑依旧由运营商侧生成或选号
      } catch (e) {
        // 忽略解析异常
      }
    },
    // 清理表单缓存
    clearFormCache() {
      try {
        localStorage.removeItem(this.formCacheKey);
      } catch (e) {
        console.log("e =>", e);
      }
    }
  },
};
</script>

<style lang="less" scoped>
@import "../assets/style/GuangzhouUnicom.less";
.small {
  font-size: 10px;
  color: #666;
}
.pBottom {
  padding-bottom: 3px;
}
.textIndent {
  padding-left: 10px;
}

.act {
  .content {
    .contentBox1 {
      .tcInfo {
        .tcInfoBox {
          padding-bottom: 50px;
        }
      }
    }
  }
  .container {
    .content {
      padding: 15px;
      .zfxqTable2 {
        border: 1px solid #799ffd;
        border-radius: 10px;
        .zTr {
          display: flex;
          align-items: center;
          border-bottom: 1px solid #799ffd;
          &:last-child {
            border-bottom: none;
          }
          .zTh {
            padding: 10px;
            box-sizing: border-box;
            color: #3e5fb2;
            text-align: center;
            font-size: 14px;
            width: 30%;
            font-weight: bold;
          }
          .zTd {
            width: 70%;
            box-sizing: border-box;
            border-left: 1px solid #799ffd;
            font-size: 13px;
            .blueText {
              color: #3e5fb2;
              font-weight: 600;
              font-size: 16px;
            }
            .zTCBox {
              display: flex;
              justify-content: space-between;
              &.bTop {
                border-top: 1px solid #3074da;
              }
              .zTCItem {
                width: 25%;
                border-right: 1px solid #3074da;
                padding: 20px 5px;
                box-sizing: border-box;
                text-align: center;
                font-size: 12px;
                &.thText {
                  font-weight: 500;
                  color: #3e5fb2;
                }
                &:last-of-type {
                  border: none;
                }
                &.w100 {
                  width: 100%;
                }
                &.textL {
                  text-align: left;
                  padding-left: 20px;
                  .smallText {
                    padding: 5px;
                  }
                }
                &.bigPadding {
                  padding: 35px 0;
                }
                .smallText {
                  padding: 5px 0;
                }
              }
            }
          }
        }
      }
      .zfxqTable3 {
        .zTr {
          display: flex;
          align-items: stretch;
          border-bottom: 1px solid #799ffd;
          &:last-child {
            border-bottom: none;
          }
          .zTh, .zTd, .z3Td {
            padding: 8px 10px;
            margin: 0;
            box-sizing: border-box;
            font-size: 12px;
            line-height: 1.5;
            vertical-align: middle;
            font-weight: normal;
          }
          .zTh {
            color: #3e5fb2;
            text-align: center;
            font-size: 12px;
            width: 18%;
            font-weight: bold;
          }
          .zTd {
            width: 33%;
            border-left: 1px solid #799ffd;
            .blueText {
              color: #3e5fb2 !important;
              font-weight: bold !important;
              font-size: 18px !important;
            }
            .blueText2 {
              color: #3e5fb2 !important;
              font-weight: bold;
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}

.tcBox {
  padding: 10px 0;
  // padding-bottom: 20px;
  .topBox {
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 0 20px;
    .close {
      color: #969799;
      padding: 15px;
    }
    .define {
      color: #576b95;
      padding: 10px;
    }
    .title {
      font-size: 18px;
      padding: 15px;
    }
  }
  .content {
    .tcItem {
      border-bottom: 1px solid #eee;
      padding: 10px 0;
      font-size: 16px;
      text-align: center;
      box-sizing: border-box;
      &:last-child {
        border: none;
      }
      &.active {
        color: #3074da;
      }
    }
  }
}

.spiImg {
  width: 100%;
  border-radius: 10px;
}

.highlight {
  background-color: #fff8e6;
  color: #ff6b00;
  padding: 12px 18px;
  border-radius: 10px;
  font-weight: 700;
  border-left: 4px solid #ff6b00;
  box-shadow: 0 2px 8px rgba(255, 193, 7, 0.08);
  margin: 16px 0 20px 0;
  font-size: 15px;
  line-height: 1.8;
}
// 警告盒子额外样式
.warning-box {
  background: linear-gradient(90deg, #fffbe6 0%, #fff3e0 100%);
  border: 1px solid #ffe0b2;
  box-shadow: 0 2px 12px rgba(255, 193, 7, 0.10);
}
.warning-list {
  margin: 0 0 0 18px;
  padding: 0;
  color: #d35400;
  font-weight: 500;
  font-size: 15px;
  list-style: disc inside;
}

.container .header2 {
  background-size: cover;
  background-position: center;
  text-align: left;
  font-size: 22px;
  font-weight: bold;
  color: #3e5fb2;
  border-radius: 10px 10px 0 0;
  box-sizing: border-box;
  height: 30px;
  padding-left: 20px;
  padding-top: 7px;
}

.zfxqTable3 .rowspan4 {
  height: 160px;
  line-height: 160px;
  text-align: center;
  vertical-align: middle;
  background: #fff;
  border-right: 1px solid #799ffd;
  border-bottom: 1px solid #799ffd;
  font-weight: bold;
}

.zfxqTable3 .zTh {
  color: #3e5fb2;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
  border-right: 1px solid #799ffd;
  border-bottom: 1px solid #799ffd;
  box-sizing: border-box;
  padding: 8px 10px;
}

.zfxqTable3 .zTh2 {
  width: 20%;
  color: #3e5fb2;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  border-right: 1px solid #799ffd;
  border-bottom: 1px solid #799ffd;
  box-sizing: border-box;
  padding: 8px 10px;
}

.zfxqTable3 table,
.zfxqTable3 th,
.zfxqTable3 td {
  border: 1px solid #799ffd;
  padding: 4px;
  border-radius: 0;
}
.zfxqTable3 table {
  border-collapse: separate;
  border-spacing: 0;
  position: relative; /* 确保伪元素可以正确放置 */
}

.zfxqTable3 .zTd {
  text-align: center;
  font-size: 14px;
  color: #3e5fb2;
}
.zfxqTable3 .zTd.left {
  text-align: left;
  padding-left: 10px;
  font-size: 13px;
  color: #19191a;
}
.zfxqTable3 .zTd .blueText {
  color: #3e5fb2;
}
.zfxqTable3 .zTd .small {
  font-size: 12px;
  color: #616060;
}
.zfxqTable3 .zTd .tipText {
  color: chocolate;
  font-size: 12px;
}


.bottomImg2 {
    width: calc(100%) ;
    display: block;
  }
</style>
